import { createContext, useState, useContext } from "react";

export const OnboardingDocumentModuleContext = createContext({});

interface OnboardingDocumentModuleProviderProps {
  children: React.ReactNode;
}

export type OnboardingDocumentModuleContextType = {
  isApprovedView: boolean;
  setIsApprovedView: (isApprovedView: boolean) => void;
};

export const useOnboardingDocumentModuleContext = () => {
  return useContext(
    OnboardingDocumentModuleContext,
  ) as OnboardingDocumentModuleContextType;
};

const OnboardingDocumentModuleProvider = ({
  children,
}: OnboardingDocumentModuleProviderProps) => {
  const [isApprovedView, setIsApprovedView] = useState(false);
  return (
    <OnboardingDocumentModuleContext.Provider
      value={{ isApprovedView, setIsApprovedView }}
    >
      {children}
    </OnboardingDocumentModuleContext.Provider>
  );
};

export default OnboardingDocumentModuleProvider;
